import { escapeHtmlEntities, getDefaultWhiteList, filterXSS } from 'xss';
export const sanitizeHtml = html => {
  const options = {
    whiteList: {
      ...getDefaultWhiteList(),
      span: ['style'],
      // in the BO rich text component transform all changes to span with style
      div: ['style'],
      // allow to override common styles for components like Agent Tooltip content
      a: ['target', 'href', 'title', 'data-hook'],
      // added data-hook for testing
      kbd: [] // multiline input field keyboard tips
    }
  };
  return filterXSS(html, options);
};
export const escapeHtml = value => {
  return escapeHtmlEntities(value);
};
//# sourceMappingURL=xss.js.map